<div class="pre-publica">
  <div class="carregando" *ngIf="carregando && !campanha">
    <nb-spinner status="primary" size="medium"></nb-spinner>
    <span>Carregando a pré-inscrição…</span>
  </div>

  <nb-card class="aviso" *ngIf="erroCampanha">
    <nb-card-body>
      <nb-icon pack="eva" icon="alert-circle-outline" class="aviso-icone"></nb-icon>
      <p>{{ erroCampanha }}</p>
    </nb-card-body>
  </nb-card>

  <ng-container *ngIf="campanha">
    <nb-card class="campanha">
      <nb-card-body>
        <h1 class="campanha-nome">{{ campanha.nome }}</h1>

        <p class="campanha-encerrada" *ngIf="campanhaEncerrada">
          <nb-icon pack="eva" icon="slash-outline"></nb-icon>
          Esta pré-inscrição está <strong>encerrada</strong>. Procure a coordenação da catequese
          para saber das próximas turmas.
        </p>

        <ng-container *ngIf="!campanhaEncerrada">
          <p class="campanha-explica">
            A idade é considerada em <strong>{{ dataBr(campanha.dataReferenciaIdade) }}</strong> — é
            ela que define o grupo. Informe a data de nascimento e a gente diz se há vaga.
          </p>

        </ng-container>
      </nb-card-body>
    </nb-card>

    <nb-card class="porta" *ngIf="!campanhaEncerrada && !preenchendoFicha">
      <nb-card-body>
        <app-campo-data
          id="pi-nasc"
          rotulo="Data de nascimento de quem vai participar"
          ajuda="Digite no formato dd/mm/aaaa, ou use o calendário ao lado."
          [valor]="dataNascimento"
          (valorChange)="aoInformarDataNaPorta($event)"
        ></app-campo-data>

        <div class="consultando" *ngIf="consultando">
          <nb-spinner status="primary" size="tiny"></nb-spinner>
          <span>Consultando vaga…</span>
        </div>

        <p class="erro" *ngIf="erroConsulta">{{ erroConsulta }}</p>

        <p class="aviso-vaga-perdida" *ngIf="avisoEnvioRecusado">{{ avisoEnvioRecusado }}</p>

        <div class="resultado" *ngIf="vaga && !consultando" [ngClass]="'resultado--' + (situacao || '')">
          <p class="resultado-mensagem">{{ vaga.mensagem }}</p>
          <p class="resultado-detalhe" *ngIf="vaga.idadeApurada != null">
            Idade considerada: <strong>{{ vaga.idadeApurada }} anos</strong>
            <ng-container *ngIf="vaga.grupo?.nome"> · Grupo: <strong>{{ vaga.grupo?.nome }}</strong></ng-container>
          </p>

          <button
            *ngIf="temVaga"
            nbButton
            status="primary"
            size="large"
            fullWidth
            type="button"
            (click)="comecarFicha()"
          >
            Preencher a ficha
          </button>
        </div>
      </nb-card-body>
    </nb-card>

    <ng-container *ngIf="preenchendoFicha">
      <nb-card class="aviso-grupo" *ngIf="avisoGrupoRefeito && !bloqueioVaga">
        <nb-card-body>
          <nb-icon pack="eva" icon="info-outline"></nb-icon>
          <span>{{ avisoGrupoRefeito }}</span>
        </nb-card-body>
      </nb-card>

      <app-inscricao
        [campanhaId]="campanhaId"
        [dataNascimentoFixa]="dataNascimento"
        (envioRecusado)="aoRecusarEnvio($event)"
        (dataNascimentoDoCpf)="aoReceberDataDoCpf($event)"
        [bloqueio]="bloqueioVaga"
      ></app-inscricao>
    </ng-container>
  </ng-container>
</div>
